import React from 'react';
import '../styles/GoalCard.css';

interface GoalCardProps {
  number: number;
  title: string;
  description: string;
}

const GoalCard: React.FC<GoalCardProps> = ({ number, title, description }) => {
  return (
    <div className="goal-card">
      <h3>{number}. {title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default GoalCard;